import React from 'react'
import { Button, ButtonProps, makeStyles, createStyles } from '@material-ui/core'
import { Link } from 'gatsby'

export type ButtonLinkProps = ButtonProps & {
  to: string
};

const useStyles = makeStyles(() => createStyles({
  link: {
    textDecoration: 'none'
  }
}))

export default function ButtonLink ({ to, ...props }: ButtonLinkProps) {
  const classes = useStyles()

  return (
    <Link
      to={to}
      className={classes.link}
    >
      <Button
        {...props}
      />
    </Link>
  )
}
